import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { AuthGaurdService } from './auth-gaurd.service';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CommSummaryModel } from '../models/commissionsummary/commsummary.model';
import { AddUser } from '../models/manageUsers/add-user.model';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  host: string = environment.apiUrl + 'reports';
  searchCriteriaSet = new Set<string>();
  public commSummaryModel = new CommSummaryModel();

  constructor(private http: HttpClient,
    private logger: LoggerService,
    private authgurdService: AuthGaurdService) { }

  public downloadZip(
    reporttype: string,
    commPlanId: string | number | number[],
    calRunId: string,
    payrollDt: string,
    salesChannel: string
  ): Observable<Blob> {
    const commPlanParam = Array.isArray(commPlanId)
      ? commPlanId.join(',')
      : String(commPlanId ?? '');
    const url = `${this.host}/getreport/${encodeURIComponent(reporttype)}/${encodeURIComponent(commPlanParam)}/${encodeURIComponent(calRunId)}/${encodeURIComponent(payrollDt)}/${encodeURIComponent(salesChannel)}`;

    return this.http.get(url, {
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'application/zip'
      })
    });
  }

  public downloadKpiEnterpriseZip(
    reporttype: string,
    commPlanId: string | number | number[],
    calRunIds: string[],
    payrollDt: string,
    salesChannel: string
  ): Observable<Blob> {
    const commPlanParam = Array.isArray(commPlanId)
      ? commPlanId.join(',')
      : String(commPlanId ?? '');
    const url = `${this.host}/getreport/${encodeURIComponent(reporttype)}/${encodeURIComponent(commPlanParam)}/${encodeURIComponent(calRunIds.join(','))}/${encodeURIComponent(payrollDt)}/${encodeURIComponent(salesChannel)}`;

    return this.http.get(url, {
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': 'application/zip'
      })
    });
  }


  public getReportTest(reporttype: string, commPlanId: string, calRunId: string, payrollDt: string): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/getreporttest/` + reporttype + '/' + commPlanId + '/' + calRunId + '/' + payrollDt);
  }

  public getReport(reporttype: string, commPlanId: string, calRunId: string, payrollDt: string): Observable<CommSummaryModel[]> {
    return this.http.get<CommSummaryModel[]>(`${this.host}/getreport/` + reporttype + '/' + commPlanId + '/' + calRunId + '/' + payrollDt);
  }

  public getUsersReport(profilestatus: string, first_name: string, last_name: string, employeeId: string, sales_rep_id: string, soft_termination_date: Date, id: any, supervisor_id: number, user_type: string, sales_rep_channel: string, comm_plan_id: number, payroll_start_date: string, userRole: string) {
    const url = this.host + '/getusersreport/' + profilestatus + '/' + first_name + '/' + last_name + '/' + employeeId + '/' + sales_rep_id + '/' + soft_termination_date + '/' + id + '/' + supervisor_id + '/' + user_type + '/' + sales_rep_channel + '/' + comm_plan_id + '/' + payroll_start_date + '/' + userRole;
    return this.http.get<CommSummaryModel[]>(url)
      .pipe(
        map((data: CommSummaryModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public clearReportsSqlCache(): Observable<string> {
    return this.http.post(`${this.host}/clearreportssqlcache`, null, { responseType: 'text' });
  }

  public downloadCompPlanReport() {
    const url = this.host + '/downloadpersonnelreport';
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }



}